// home/GoProactiveSection.jsx — now "The Solution" section
import React from 'react';
import { Cpu, Globe, Moon } from 'lucide-react';
import { getAssetUrl } from '../../utils/assetUrl';

const pillars = [
  {
    icon: Cpu,
    title: 'Multi-Modal Intelligence',
    body: 'Fuses facial recognition, behavioral analytics, object detection, and access control into one unified model — not bolted-together point solutions.',
    accentBorder: 'border-t-primary',
  },
  {
    icon: Globe,
    title: 'Universal Integration',
    body: 'Meraki, Axis, Hanwha, or any RTSP stream. If it sends video, Kinetic Guard sees it. No rip-and-replace. No vendor lock-in.',
    accentBorder: 'border-t-primary',
  },
  {
    icon: Moon,
    title: 'The Dark SOC',
    body: 'Automate 90% of monitoring tasks. Your team focuses on the 10% that requires human judgment. The rest runs autonomously, 24/7.',
    accentBorder: 'border-t-accent-orange',
  },
];

const vendorLogos = [
  { src: '/cisco-meraki.png', alt: 'Cisco Meraki' },
  { src: '/axis-communications.png', alt: 'Axis Communications' },
  { src: '/hanwha-vision.png', alt: 'Hanwha Vision' },
];

export function GoProactiveSection() {
  return (
    <div id="solution" className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-base text-primary font-semibold tracking-wide uppercase">The Kinetic Guard Approach</h2>
          <p className="mt-2 text-3xl leading-8 font-bold tracking-tight text-foreground sm:text-4xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Hardware Agnostic. Intelligence Driven.
          </p>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground mx-auto">
            We don't sell you cameras. We sell you a brain that works with the cameras you already have.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {pillars.map((pillar) => {
            const Icon = pillar.icon;
            return (
              <div key={pillar.title} className={`bg-card border border-border border-t-2 ${pillar.accentBorder} rounded-lg p-8`}>
                <Icon className="h-10 w-10 text-primary mb-4" />
                <h3 className="text-xl font-semibold text-foreground mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  {pillar.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {pillar.body}
                </p>
              </div>
            );
          })}
        </div>

        {/* Vendor logos */}
        <div className="mt-16 text-center">
          <p className="text-xs text-muted-foreground uppercase tracking-widest mb-6">Works with your existing infrastructure</p>
          <div className="flex items-center justify-center gap-8 flex-wrap">
            {vendorLogos.map((logo) => (
              <img
                key={logo.alt}
                src={getAssetUrl(logo.src)}
                alt={logo.alt}
                className="h-8 opacity-40 hover:opacity-70 transition-opacity"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
